import { ColDef } from 'ag-grid-enterprise';
import { UserCell } from './UserCell';

export type Member = {
  email: string;
  fullName: string | null;
  imageUrl: string;
  role: string;
  joined: Date;
};

export const colDefsMembersTable: ColDef<Member>[] = [
  {
    field: 'fullName',
    headerName: 'User',
    cellRenderer: UserCell,
    sortable: true,
    filter: true,
    type: 'w200',
    autoHeight: true,
    cellClass: 'flex align-items-center justify-content-left',
    wrapText: true,
  },
  {
    field: 'joined',
    headerName: 'Joined',
    sortable: true,
    cellClass: 'flex align-items-center justify-content-left',
    type: 'w120',
    filter: true,
  },
  {
    field: 'role',
    headerName: 'Role',
    cellClass: 'flex align-items-center justify-content-left capitalize',
    type: 'w200',
    sortable: true,
    filter: true,
  },
];
